export default __webpack_public_path__ + "static/media/ribbon2.e346da38.jpg";